import { SxProps, Theme } from '@mui/material';
import { TicketSource } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { Ticket } from '~hooks/useTickets/models';
import { Nullable } from '~types/Nullable';

interface SourceColumnProps {
  ticket: Ticket;
  sx?: SxProps<Theme>;
}

const getSourceLabel = (source: Nullable<TicketSource>) => {
  switch (source) {
    case TicketSource.API_INTEGRATION:
      return t('dispatch.tickets_table.source.api');
    case TicketSource.WEB:
      return t('dispatch.tickets_table.source.web');
    case TicketSource.DRIVER_APP:
      return t('dispatch.tickets_table.source.mobile');
    case TicketSource.AGENT:
      return t('dispatch.tickets_table.source.agent');
    default:
      return '-';
  }
};

export default function SourceColumn({ ticket, sx }: SourceColumnProps) {
  const translatedSource = getSourceLabel(ticket.source);

  return (
    <FlexColumn sx={sx}>
      <OverflowAwareText>{translatedSource}</OverflowAwareText>
    </FlexColumn>
  );
}
